/*!
 * Wish Karo - Hover Zoom (desktop only)
 * Amazon-style: hover a product photo, a magnified pane opens on the right.
 * - No dependencies, ~4 KB. Does nothing on phones/tablets or screens < 990px.
 * - Hi-res image is fetched only on first hover (Shopify CDN width param), never on page load.
 * To disable: remove the render line for 'wk-hover-zoom' in snippets/product-media-modal.liquid.
 */
(function () {
  'use strict';
  if (window.__wkHoverZoom) return;
  window.__wkHoverZoom = true;

  var DESKTOP = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SEL = 'media-gallery .product__media-list .product-media-container.media-type-image';
  var EXCLUDE = 'quick-add-modal, product-modal, .quick-add-modal';
  var MAX_ZOOM = 2.6;   // max magnification
  var MIN_GAIN = 1.2;   // skip zoom if the photo has no extra resolution
  var GAP = 20;         // space between gallery and pane
  var EDGE = 16;        // min distance from viewport edges
  var MIN_PANE = 280;
  var MAX_PANE = 640;
  var EASE = 0.3;       // lens follow smoothing (1 = instant)

  var pane, paneImg, lens;
  var st = null;
  var px = 0, py = 0;
  var raf = 0, scrollQueued = false, bound = false;
  var loaded = Object.create(null);

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  function build() {
    if (pane) return;
    pane = el('div', 'wk-zoom-pane');
    pane.setAttribute('aria-hidden', 'true');
    paneImg = el('img');
    paneImg.alt = '';
    paneImg.decoding = 'async';
    paneImg.draggable = false;
    pane.appendChild(paneImg);
    pane.appendChild(el('span', 'wk-zoom-pane__loader'));
    lens = el('div', 'wk-zoom-lens');
    lens.setAttribute('aria-hidden', 'true');
    document.body.appendChild(pane);
    document.body.appendChild(lens);
  }

  // Largest width Shopify offered in srcset = best resolution we know exists.
  function srcsetMax(img) {
    var max = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (s) {
      var m = s.trim().match(/\s(\d+)w$/);
      if (m) max = Math.max(max, +m[1]);
    });
    return max || img.naturalWidth || 0;
  }

  function sized(src, w) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', w);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) {
      return src;
    }
  }

  function headerBottom() {
    var h = document.querySelector('sticky-header, .header-wrapper, .section-header');
    if (!h) return 0;
    var b = h.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }

  // Visible picture area (handles object-fit: contain letterboxing).
  function measure(img, fit) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (nw && nh && (fit === 'contain' || fit === 'scale-down')) {
      var s = Math.min(r.width / nw, r.height / nh);
      var w = nw * s, h = nh * s;
      return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
    }
    return { left: r.left, top: r.top, width: r.width, height: r.height };
  }

  function layout() {
    var c = measure(st.img, st.fit);
    if (c.width < 80 || c.height < 80) return false;
    if (st.res / c.width < MIN_GAIN) return false;

    var g = (st.box.closest('media-gallery') || st.box).getBoundingClientRect();
    var left = Math.round(g.right + GAP);
    var w = Math.min(MAX_PANE, window.innerWidth - left - EDGE);
    if (w < MIN_PANE) return false;

    var minTop = Math.max(EDGE, headerBottom() + 8);
    var h = Math.min(c.height, w * 1.3, window.innerHeight - minTop - EDGE);
    if (h < 200) return false;

    var z = Math.min(MAX_ZOOM, st.res / c.width);
    z = Math.max(z, w / c.width, h / c.height); // lens must fit inside the photo

    var top = clamp(c.top, minTop, window.innerHeight - h - EDGE);

    st.c = c;
    st.z = z;
    st.lw = w / z;
    st.lh = h / z;

    pane.style.width = w + 'px';
    pane.style.height = Math.round(h) + 'px';
    pane.style.setProperty('--x', left + 'px');
    pane.style.setProperty('--y', Math.round(top) + 'px');
    paneImg.style.width = c.width * z + 'px';
    paneImg.style.height = c.height * z + 'px';
    lens.style.width = st.lw + 'px';
    lens.style.height = st.lh + 'px';
    return true;
  }

  function aim() {
    var c = st.c;
    st.tx = clamp(px - c.left - st.lw / 2, 0, c.width - st.lw);
    st.ty = clamp(py - c.top - st.lh / 2, 0, c.height - st.lh);
  }

  function frame() {
    raf = 0;
    if (!st) return;
    var k = REDUCED.matches || st.snap ? 1 : EASE;
    st.snap = false;
    st.x += (st.tx - st.x) * k;
    st.y += (st.ty - st.y) * k;
    var c = st.c;
    lens.style.transform = 'translate3d(' + (c.left + st.x) + 'px,' + (c.top + st.y) + 'px,0)';
    paneImg.style.transform = 'translate3d(' + -st.x * st.z + 'px,' + -st.y * st.z + 'px,0)';
    if (Math.abs(st.tx - st.x) > 0.3 || Math.abs(st.ty - st.y) > 0.3) tick();
  }

  function tick() {
    if (!raf) raf = requestAnimationFrame(frame);
  }

  function activate(box) {
    var img = box.querySelector('.product__media img');
    if (!img || !img.complete || !img.naturalWidth) return;
    build();
    st = {
      box: box,
      img: img,
      fit: getComputedStyle(img).objectFit,
      res: srcsetMax(img),
      x: 0, y: 0, tx: 0, ty: 0,
      snap: true
    };
    if (!layout()) {
      st = null;
      return;
    }

    var low = img.currentSrc || img.src;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var want = Math.min(3000, Math.ceil((st.c.width * st.z * dpr) / 100) * 100);
    var hi = sized(low, want);

    paneImg.src = loaded[hi] ? hi : low; // show sharp-ish instantly, upgrade when ready
    pane.classList.toggle('is-loading', !loaded[hi]);

    if (!loaded[hi]) {
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function () {
        var done = function () {
          loaded[hi] = true;
          if (st && st.img === img) {
            paneImg.src = hi;
            pane.classList.remove('is-loading');
          }
        };
        if (pre.decode) pre.decode().then(done, done);
        else done();
      };
      pre.onerror = function () {
        if (st && st.img === img) pane.classList.remove('is-loading');
      };
      pre.src = hi;
    }

    aim();
    box.classList.add('wk-zoom-on');
    pane.classList.add('is-visible');
    lens.classList.add('is-visible');
    tick();
  }

  function deactivate() {
    if (!st) return;
    st.box.classList.remove('wk-zoom-on');
    st = null;
    if (pane) {
      pane.classList.remove('is-visible');
      lens.classList.remove('is-visible');
    }
  }

  function onMove(e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    px = e.clientX;
    py = e.clientY;
    var t = e.target;
    var box = t && t.closest ? t.closest(SEL) : null;
    if (box && box.closest(EXCLUDE)) box = null;
    if (!box) {
      deactivate();
      return;
    }
    if (!st || st.box !== box) {
      deactivate();
      activate(box);
      if (!st) return;
    }
    aim();
    tick();
  }

  function onScroll() {
    scrollQueued = false;
    if (!st) return;
    var b = st.box.getBoundingClientRect();
    if (px < b.left || px > b.right || py < b.top || py > b.bottom || !layout()) {
      deactivate();
      return;
    }
    aim();
    st.snap = true;
    tick();
  }

  function onScrollRaf() {
    if (st && !scrollQueued) {
      scrollQueued = true;
      requestAnimationFrame(onScroll);
    }
  }

  function onClick() {
    deactivate(); // opening the lightbox should never leave the pane floating
  }

  function onVisibility() {
    if (document.hidden) deactivate();
  }

  function bind() {
    var on = DESKTOP.matches;
    if (on === bound) return;
    var m = on ? 'addEventListener' : 'removeEventListener';
    document[m]('pointermove', onMove, { passive: true });
    document.documentElement[m]('mouseleave', deactivate);
    document[m]('click', onClick, true);
    document[m]('visibilitychange', onVisibility);
    window[m]('scroll', onScrollRaf, { passive: true });
    window[m]('resize', deactivate, { passive: true });
    window[m]('blur', deactivate);
    if (!on) deactivate();
    bound = on;
  }

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', bind);
  else if (DESKTOP.addListener) DESKTOP.addListener(bind);
  bind();
})();
